import * as React from "react";
const SvgDensityMedium = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3z",
  fill: "currentColor"
}));
export default SvgDensityMedium;